import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;